import { cn } from '@/lib/utils';

interface FrogWaitAnimationProps {
  /** Optional additional CSS class names */
  className?: string;
}

/**
 * Displays a looping transparent animated WebP of the frog chewing dice.
 * Shown during dice recognition while rollState === 'capturing'.
 *
 * @example
 * <FrogWaitAnimation className="mx-auto" />
 */
export function FrogWaitAnimation({ className }: FrogWaitAnimationProps) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="rounded-full bg-black/50 p-5 shadow-lg backdrop-blur-sm">
        <img
          src="/images/frog/eating-frog-animation.webp"
          alt="Frog munching dice"
          width={120}
          height={120}
          className="rounded-full"
        />
      </div>
    </div>
  );
}
